import lazyLoadOnRender from '@ms/yammer-web-components/dist/lazy/loadOnRender';

const suggestedActionsLightbox = () =>
  import(/* webpackChunkName: "4-feat-suggested-actions-lightbox" */ './SuggestedActionsLightbox');

export default lazyLoadOnRender({ loader: suggestedActionsLightbox });
